angular.module('rjmNg.common.api').factory('Webhooks', [
  "$resource"
  "serviceUrl"
  (
    $resource,
    serviceUrl
  ) ->

    getResource = (clientId) ->

      webhooksBaseUrl = "/clients/#{clientId}/endpoints/"


      defaultParams =
        withCredentials: true
        headers:
          Accept: 'application/json'
          'Content-Type': 'application/json'

      actions =
        getAll: angular.extend {}, defaultParams,
          method: 'GET'
          isArray: true
          url: serviceUrl(webhooksBaseUrl)
        get: angular.extend {}, defaultParams,
          method: 'GET'
          isArray: false
          url: serviceUrl(webhooksBaseUrl + ':id')
          id: '@id'
        create: angular.extend {}, defaultParams,
          method: 'POST'
          url: serviceUrl(webhooksBaseUrl)
        put: angular.extend {}, defaultParams,
          method: 'PUT'
          url: serviceUrl(webhooksBaseUrl + ':id')
          id: '@id'

      webhooks = $resource(serviceUrl(webhooksBaseUrl), {}, actions)

    pareModel = (model) ->
      id: model.id
      table_name: model.table_name
      type: model.type
      client_id: model.client_id
      connection_id: model.connection_id
      is_deleted: model.is_deleted
      product: model.product

    (clientId) ->

      webhooks = getResource clientId

      get: (id = null) ->
        if id?
          return webhooks.get({id: id}).$promise

        webhooks.getAll().$promise

      create: (model) ->
        paredModel = pareModel model
        webhooks.create(paredModel).$promise

      delete: (model) ->
        paredModel = pareModel model
        paredModel.is_deleted = 1
        webhooks.put(id: paredModel.id, paredModel).$promise
  ]
)
